import { createAsyncThunk } from "@reduxjs/toolkit";

import CameraAPI from "~/apis/CameraAPI";

export const createStream = createAsyncThunk(
  "cameras/createStream",
  async ({ deviceId, organizationId }, thunkAPI) => {
    try {
      const response = await CameraAPI.createStream({
        deviceId,
        organizationId
      });

      return { stream: response.data };
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response);
      }
    }
  }
);
